import { Directive, HostListener, inject } from "@angular/core";
import { isOfType } from "@bitwarden/web-vault/app/models/types/general-types";
import {
  AvailablePaymentCycles,
  PlanOption,
  PlanOptions,
  MONTH,
  YEAR,
  SubscriptionPaymentCycle,
} from "@bitwarden/web-vault/app/models/types/subscription.type";
import { StripeConfigService } from "@bitwarden/web-vault/app/services/api/stripe-config.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { AppStateStoreService } from "@bitwarden/web-vault/app/services/store/app-state/app-state.store.service";
import { AppleConfigService } from "@bitwarden/web-vault/app/services/api/apple-config.service";
import { Router } from "@angular/router";
import { PaymentService } from "@bitwarden/web-vault/app/services/subscription/payment.service";

@Directive()
export class MembershipPlanDirective {
  protected readonly YEAR = YEAR;
  protected readonly MONTH = MONTH;
  protected userStoreService = inject(UserStoreService);
  protected router: Router = inject(Router);
  protected stripeConfigService = inject(StripeConfigService);
  protected appState: AppStateStoreService = inject(AppStateStoreService);
  protected appleConfigService: AppleConfigService = inject(AppleConfigService);
  protected paymentService = inject(PaymentService);
  protected stripeButtonAvailable = this.paymentService.stripeButtonAvailable;

  protected selectPlan(value: string) {
    this.paymentService.selectPlan(value);
  }

  protected async confirmSubscription() {
    await this.paymentService.confirmSubscription();
  }

  protected async handlePlanSubmit(withCard: boolean = false) {
    await this.paymentService.handlePlanSubmit(withCard);
  }
}
